// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.simple-card-module__card___an5Jk {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  background-color: var(--surface1, #fff);
  padding: 16px;
  border-radius: 16px;
  box-shadow: 8px 8px 40px 0px rgba(20, 20, 20, 0.1019607843);
  text-align: start;
}
.simple-card-module__card--no-shadow___gSKfc {
  box-shadow: none;
}
.simple-card-module__card--outline___ag4uL {
  border: 1px solid var(--neutral30, #e3e6e8);
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/simple-card/simple-card.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,YAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,2DAAA;EACA,iBAAA;AAMF;AAJE;EACE,gBAAA;AAMJ;AAHE;EACE,2CAAA;AAKJ","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils.scss';\n\n.card {\n  appearance: none;\n  border: none;\n  background-color: color(surface1);\n  padding: 16px;\n  border-radius: $border-radius;\n  box-shadow: 8px 8px 40px 0px #1414141a;\n  text-align: start;\n\n  &--no-shadow {\n    box-shadow: none;\n  }\n\n  &--outline {\n    border: 1px solid color(neutral30);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `simple-card-module__card___an5Jk`,
	"card--no-shadow": `simple-card-module__card--no-shadow___gSKfc`,
	"card--outline": `simple-card-module__card--outline___ag4uL`
};
export default ___CSS_LOADER_EXPORT___;
